import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { dateFormat } from '@utils/config'
import { formatDate } from '@utils/date.utils'

import { CorporateActionDto } from '@model/CorporateActionDto'
import { CurrencyType } from '@model/WalletDto'

import { useFormatNumber } from '@hooks/useFormatNumber'
import { useGenerateDocumentFile } from '@hooks/useGenerateDocumentFile'

export const useStockDividendsFile = (rows: CorporateActionDto[]) => {
  const { t } = useTranslation()
  const { formatMoney } = useFormatNumber()

  const tableBody = useMemo(() => {
    const header = [
      [
        t('Stock Dividends.Name'),
        t('Stock Dividends.Symbol'),
        t('Stock Dividends.Dividend Ex Date'),
        t('Stock Dividends.Gross Dividend Amount'),
      ],
    ]
    return rows.reduce<string[][]>((acc, x) => {
      acc.push([
        x.instrument.name ?? '',
        x.instrument.symbol ?? '',
        x.date ? formatDate(x.date, { formatType: dateFormat }) : '',
        formatMoney(
          x.corporateActionDividend?.rate ?? 0,
          (x.corporateActionDividend?.currencyId ?? 'USD') as CurrencyType
        ),
      ])
      return acc
    }, header)
  }, [rows, t, formatMoney])

  return useGenerateDocumentFile('stock_dividends_report', tableBody)
}
